import { render, staticRenderFns } from "./AddBlacklistCustom.vue?vue&type=template&id=2a5e3426&"
import script from "./AddBlacklistCustom.vue?vue&type=script&lang=js&"
export * from "./AddBlacklistCustom.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports